import { render } from "./ContactsAddModalV2.vue?vue&type=template&id=2549aa75&ts=true"
import script from "./ContactsAddModalV2.vue?vue&type=script&lang=ts"
export * from "./ContactsAddModalV2.vue?vue&type=script&lang=ts"

import exportComponent from "/private/var/folders/vw/10njjg05563b0tmym_8x7zf80000gp/T/deploy/contacts-ui/470658e7ad14655c6342f4e27966e9c089bd0e53/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.4.31_vue@3.4.31_typescript@5.5.3__webpack@5.92.1_webpack-cli@5.1.4_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__